var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"size":_vm.size,"title":_vm.title,"hide-footer":"","no-close-on-backdrop":"","static":_vm.isStatic,"lazy":_vm.isLazy},on:{"hide":() => _vm.$emit('on-hide')},scopedSlots:_vm._u([{key:"modal-header-close",fn:function(){return [_c('i',{staticClass:"fa fa-close"})]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }